export const QUERY_STALE_TIME = 300000 // 5 minutes
export const QUERY_CACHE_TIME = 600000 // 10 minutes
export const QUERY_POLLING_INTERVAL = 3000 // 3 seconds
